// This is a reusable reducer that returns a state with CRUD actions statuses.
// The state holds statuses for actions that end with _REQUEST, _SUCCESS, _ERROR
// When a resource id is present, it holds a status for each individual resource
// Without id, it holds an overall status for an action
// State example:
// {
//   'RESOURCES/FETCH': {
//     all: { status: 'pending' }
//   },
//   'RESOURCE/UPDATE': {
//     1: { status: 'failed', errors: [] },
//     2: { status: 'succeeded', meta: {} },
//     3: { status: 'pending' }
//   }
//   'RESOURCE/DELETE': {
//     4: { status: 'failed', errors: [] },
//     5: { status: 'pending' }
//   }
// }

import produce from 'immer';
import * as consts from './constants';

export const initialState = {};

const actionRegexp = /(.+\/.+)_(REQUEST|SUCCESS|ERROR)$/;
const statusMap = {
  REQUEST: consts.PENDING,
  SUCCESS: consts.SUCCEEDED,
  ERROR: consts.FAILED,
};

export default (state = initialState, action) => {
  const { type, errors, meta, actionUid, id = consts.ALL_RESOURCES } = action;

  const found = type && type.match(actionRegexp);
  const uid = actionUid || id;

  if (!found) {
    return state;
  }

  const [, actionName, status] = found;

  const currentActionState = state[actionName] || {};
  const actionInfo = {
    status: statusMap[status],
    meta,
    errors,
  };
  const newState = { ...currentActionState, [uid]: actionInfo };

  return produce(state, (draftState) => {
    draftState[actionName] = newState;
  });
};
